import { GetQuoteUrl, GetQuoteDividendUrl, GetQuoteEarningsUrl } from '../constants';
import { GetQuoteExtendedUrl } from '../constants';
import _ from 'lodash';
import Axios from 'axios';
export function GetQuotes(api) {
    return (symbol) => {
        var symbs = _.isArray(symbol) ? symbol : [symbol];
        const cancelToken = Axios.CancelToken.source();
        return [api.get(GetQuoteUrl, { symbols: symbs.join(','), cancelToken: cancelToken.token }), cancelToken];
    };
}
export function GetQuotesExtended(api) {
    return (symbol) => {
        return api.get(GetQuoteExtendedUrl, { symbol: symbol });
    };
}
function GetQuoteDividends(api) {
    return (range, symbol) => {
        return api.get(GetQuoteDividendUrl, { symbol, range });
    };
}
function GetEarnings(api) {
    return (symbol, period) => {
        return api.get(GetQuoteEarningsUrl, { symbol, period });
    };
}
export function GetQuotesCharting(api) {
    return (symbol) => {
        var symbs = _.isArray(symbol) ? symbol : [symbol];
        return api.get(GetQuoteUrl, { symbols: symbs.join(',') });
    };
}
export const quotes = (api) => ({
    get: GetQuotes(api),
    extended: GetQuotesExtended(api),
    dividends: GetQuoteDividends(api),
    earnings: GetEarnings(api),
    getChartingFeed: GetQuotesCharting(api),
});
//# sourceMappingURL=quote.js.map